import { type FC, useState } from "react";
import { useApiCall, ValidationError } from "../api/api";
import type { Inspection } from "../api/dto/Inspection";
import { Input } from "../components/form/Input";
import { ModalFooter } from "../components/layout/ModalProvider";
import { useRefresh } from "../components/RefreshController";

export const EditInspectionContactModal: FC<{ inspection: Inspection; onFinish?: () => void }> = (
  props,
) => {
  const { updateInspectionContact } = useApiCall();
  const [name, setName] = useState<string>(props.inspection.contactName ?? "");
  const [email, setEmail] = useState<string>(props.inspection.contactEmail ?? "");
  const [phone, setPhone] = useState<string>(props.inspection.contactPhone ?? "");
  const [extra, setExtra] = useState<string>(props.inspection.contactExtra ?? "");
  const [errors, setErrors] = useState<string[]>([]);

  const refresh = useRefresh();

  const save = async () => {
    await updateInspectionContact(
      props.inspection.id,
      name.trim(),
      email.trim(),
      phone.trim(),
      extra.trim(),
    ).catch((e) => {
      if (e instanceof ValidationError) {
        setErrors(Object.values(e.errors).flat());
      }
      throw e;
    });
    props.onFinish?.();
    refresh();
  };
  return (
    <div className={""}>
      <div className={"uppercase text-xs text-slate-500 mt-3"}>Contactgegevens (optioneel)</div>
      <div className={"grid grid-cols-1 gap-3 border border-slate-200 rounded-sm px-2 py-2"}>
        <Input type={"text"} label={"Naam"} value={name} onChange={setName} />
        <Input type={"text"} label={"E-mail"} value={email} onChange={setEmail} />
        <Input type={"text"} label={"Telefoon"} value={phone} onChange={setPhone} />
        <Input type={"text"} label={"Extra"} value={extra} onChange={setExtra} />
      </div>
      <ModalFooter text={"Opslaan"} onSubmit={save} />
    </div>
  );
};
